getPhenixCookie();
// Add your JS customizations here
window.onload = function ($) {
    jQuery('.main-slider').slick({
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        //centerMode: true,
        prevArrow: "<div class='arrow-bg-left'><div class='slick-prev pull-left'></div></div>",
        nextArrow: "<div class='arrow-bg-right'><div class='slick-next pull-right'></div></div>",
    });

    var modal = jQuery("#search-modal");
    var btn = jQuery(".search-icon");
    var span = jQuery(".close");
    var offcanvas = jQuery(".offcanvas");

    // When the user clicks on the button, open the modal
    btn.click(function () {
        modal.css({
            "display": "block",
        });
        jQuery(".offcanvas-backdrop").css({
            "display": "none",
        })
        setTimeout(function () {
            modal.css({
                "opacity": "1"
            });
            offcanvas.toggleClass("show");
        }, 100);
    });

    // When the user clicks on <span> (x), close the modal
    span.click(function () {
        modal.css({
            "opacity": "0"
        });
        setTimeout(function () {
            modal.css({
                "display": "none",
            });
        }, 100);
    });

    // When the user clicks anywhere outside of the modal, close it
    jQuery(window).click(function (event) {
        if (event.target === modal.get(0)) {
            modal.css({
                "opacity": "0"
            });
            setTimeout(function () {
                modal.css({
                    "display": "none",
                });
            }, 100);
        }
    });

    jQuery('.magazine-slider, .product-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: 'linear',
        speed: 1000,
        dots: false,
        arrows: false,
    });

    if (jQuery('.subscription-slider .subscription-card').length > 3) {
        jQuery('.subscription-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            autoplay: false,
            cssEase: 'linear',
            speed: 1000,
            dots: false,
            arrows: true,
            centerMode: true,
            prevArrow: '<img class="slick-prev" src="/wp-content/themes/understrap-child-main/src/public/images/arrow-left.svg" alt="Previous" />',
            nextArrow: '<img class="slick-next" src="/wp-content/themes/understrap-child-main/src/public/images/arrow-right.svg" alt="Next" />',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false
                    }
                }
            ]
        });
    }

    jQuery('a.wc-menu-cart__toggle-button').on('click', function(event){
        event.preventDefault();
        jQuery('.wc-menu-cart__container').toggleClass('show');
    });

    jQuery(document).on('click', function(event) {
        if (!jQuery(event.target).closest('.wc-menu-cart__container, a.wc-menu-cart__toggle-button').length) {
            jQuery('.wc-menu-cart__container').removeClass('show');
        }
    });
}


function copyLink() {
    navigator.clipboard.writeText(window.location.href);
    console.log("copie");
    document.getElementById("custom-tooltip").style.display = "block";
    setTimeout(function () {
        document.getElementById("custom-tooltip").style.display = "none";
    }, 3000);
}

function sharePost() {
    jQuery("#share-widget").hide();
    jQuery("#share-icons").css("display", "flex").hide().fadeIn();

    // Si vous voulez également cacher 'share-widget' avec une animation,
    // vous pouvez décommenter la ligne suivante pour une transition plus douce
    // jQuery("#share-widget").fadeOut();
}


function loadMorePosts(post_type, url, category, subcategory, tag, paged, posts_per_page, offset, searchQuery, page, postVisible) {
    jQuery.ajax({
        url: url,
        type: 'GET',
        data: {
            action: 'load_more_posts',
            post_type: post_type,
            category: category,
            subcategory: subcategory,
            posts_per_page: posts_per_page,
            offset: offset,
            paged: paged,
            searchQuery: searchQuery,
            page: page,
            postVisible: postVisible,
            tag : tag
        },
        success: function (response) {
            if (response) {
                jQuery('#post-row').append(response.posts);
                if (response.is_last_page == true) {
                    jQuery('#load-more').hide();
                }
            }
        }
    });
}

function getPhenixCookie()
{
    if (localStorage.getItem('phenix_cookie')) {
        return localStorage.getItem('phenix_cookie');
    }
    var base0 = 100000000;
    var datePart = Date.now().toString(36);
    var randomPart1 = Math.floor(base0 + Math.random()*base0).toString(36);
    var randomPart2 = Math.floor(base0 + Math.random()*base0).toString(36);
    var finalCookie = (datePart + randomPart1 + randomPart2).substring(0,20);
    localStorage.setItem('phenix_cookie', finalCookie);
    return finalCookie;
}

document.addEventListener('DOMContentLoaded', function () {
    // Desktop uniquement
    if (window.innerWidth >= 992) {
        document.querySelectorAll('.navbar .dropdown').forEach(function (dropdown) {

            const menu = dropdown.querySelector('.dropdown-menu');
            if (!menu) return;

            dropdown.addEventListener('mouseenter', function () {
                dropdown.classList.add('show');
                menu.classList.add('show');
            });

            dropdown.addEventListener('mouseleave', function () {
                dropdown.classList.remove('show');
                menu.classList.remove('show');
            });
        });
    }
});

